import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useSelector } from "react-redux";
const DateRangePicker = ({ onApply, onCancel }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);

  const isDateDisabled = (date) => {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    return date > today;
  };

  const isDateSelected = (date) => {
    if (!startDate && !endDate) return false;
    const dateTime = date.getTime();
    return dateTime === startDate?.getTime() || dateTime === endDate?.getTime();
  };

  const isDateInRange = (date) => {
    if (!startDate || !endDate) return false;
    const dateTime = date.getTime();
    return dateTime > startDate.getTime() && dateTime < endDate.getTime();
  };

  const handleDateClick = (date) => {
    if (isDateDisabled(date)) return;
    
    // Normalize date to midnight
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    
    if (!startDate || (startDate && endDate)) {
      // Start new range
      setStartDate(normalizedDate);
      setEndDate(null);
    } else {
      // Set end date
      if (normalizedDate < startDate) {
        setEndDate(startDate);
        setStartDate(normalizedDate);
      } else {
        setEndDate(normalizedDate);
      }
    }
  };

  const navigateMonth = (direction) => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() + direction);
    setCurrentMonth(newMonth);
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    return days;
  };

  const handleApply = () => {
    if (startDate && endDate) {
      onApply({ startDate, endDate });
    }
  };

  return (
    <>
      <div className="sales-date-picker-backdrop" onClick={onCancel}></div>
      <div className="sales-date-picker">
        <div className="sales-date-picker-header">
          <button
            className="sales-date-picker-nav-btn"
            onClick={() => navigateMonth(-1)}
          >
            <ChevronDown size={16} style={{ transform: "rotate(90deg)" }} />
          </button>
          <h3 className="sales-date-picker-month-year">
            {currentMonth.toLocaleDateString("en-US", {
              month: "long",
              year: "numeric",
            })}
          </h3>
          <button
            className="sales-date-picker-nav-btn"
            onClick={() => navigateMonth(1)}
          >
            <ChevronDown size={16} style={{ transform: "rotate(-90deg)" }} />
          </button>
        </div>

        <div className="sales-date-picker-weekdays">
          <div className="sales-weekday">Su</div>
          <div className="sales-weekday">Mo</div>
          <div className="sales-weekday">Tu</div>
          <div className="sales-weekday">We</div>
          <div className="sales-weekday">Th</div>
          <div className="sales-weekday">Fr</div>
          <div className="sales-weekday">Sa</div>
        </div>

        <div className={isPartsURL ? "sales-date-picker-days-parts" : isAccessoriesURL ? "sales-date-picker-days-acc" : "sales-date-picker-days"}>
          {getDaysInMonth(currentMonth).map((day, index) => (
            <div
              key={index}
              className={`${isPartsURL ? "sales-date-picker-day-parts" : isAccessoriesURL ? "sales-date-picker-day-acc" : "sales-date-picker-day"} ${day ? "" : "empty"} ${
                day && isDateDisabled(day) ? "disabled" : ""
              } ${day && isDateSelected(day) ? "selected" : ""} ${
                day && isDateInRange(day) ? "in-range" : ""
              }`}
              onClick={() => day && handleDateClick(day)}
            >
              {day ? day.getDate() : ""}
            </div>
          ))}
        </div>

        <div className="sales-date-picker-actions">
          <button className="sales-date-picker-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            className={
              isPartsURL
                ? "sales-date-picker-apply-parts"
                : isAccessoriesURL
                ? "sales-date-picker-apply-acc"
                : "sales-date-picker-apply"
            }
            onClick={handleApply}
            disabled={!startDate || !endDate}
          >
            Apply
          </button>
        </div>
      </div>
    </>
  );
};

export default DateRangePicker;
